import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = () =>
  Boolean(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId);

/** Lists missing REACT_APP_FIREBASE_* vars (for clearer errors in dev). */
export const getMissingFirebaseEnvVars = () => {
  const keys = [
    ['REACT_APP_FIREBASE_API_KEY', firebaseConfig.apiKey],
    ['REACT_APP_FIREBASE_AUTH_DOMAIN', firebaseConfig.authDomain],
    ['REACT_APP_FIREBASE_PROJECT_ID', firebaseConfig.projectId],
    ['REACT_APP_FIREBASE_STORAGE_BUCKET', firebaseConfig.storageBucket],
    ['REACT_APP_FIREBASE_MESSAGING_SENDER_ID', firebaseConfig.messagingSenderId],
    ['REACT_APP_FIREBASE_APP_ID', firebaseConfig.appId],
  ];
  return keys.filter(([, value]) => !value).map(([name]) => name);
};

export const getFirebaseConfigError = () => {
  const missing = getMissingFirebaseEnvVars();
  if (missing.length === 0) return null;
  return `Firebase is not configured. Missing: ${missing.join(', ')}. Add them to .env.development (local) or .env.production / Vercel env vars, then restart npm start or redeploy.`;
};

/** Avoid initializeApp with missing apiKey — that throws auth/invalid-api-key at module load. */
let firebaseAuth = null;
if (isFirebaseConfigured()) {
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  firebaseAuth = getAuth(app);
}

export { firebaseAuth };

